import { Auth } from "aws-amplify";
import { getToken, getResponse, signOutAll } from "fc-sso";
import { jwtDecode } from "jwt-decode";

export const getCurrentAuthenticatedUser = async () => {
  try {
    let token = await getToken();
    if (!token) {
      const response = await Auth.currentAuthenticatedUser().token
        return {
          ...response,
          userName: response?.username, //Mapping the userName and emailAddr to be consistent with SSO
          emailAddr: response?.attributes.email,
        };
    } else {
      const response = await getResponse()
      const result = response?.user[0];
      return result;          
    }    
  } catch (error) {
    // Handle error appropriately
    console.error("Error:", error);
  }
};

export const getSessionToken = async () => {
  try {
    let token = await getToken();
    if (!token) {
      const session = await Auth.currentSession()
      token = session.getIdToken().getJwtToken();
    }
    return token;
  } catch (error) {
    console.error("Error getting session token:", error);
    return null;
  }
};

export const signOutApp = async () => {
  try {
    const token = await getToken();
    localStorage.clear();
    if (!token) {
      await Auth.signOut();
    } else {
      await signOutAll();
    }
  } catch (error) {
    console.error("Error:", error);
  }
};